import classes from './ccf-call-conference.module.scss';
import { Card, CardContent, Divider } from '@mui/material';
import {
  selectCallConferenceStatus,
  selectUserInConference,
  selectUserInLobby,
  ccfCallActions,
  User,
  selectTileDirection,
} from './ccf-call-conference.slice';

import {
  callConferenceCommonIcons,
  callConferenceHoldIcons,
  callConferenceIcons,
} from './+data';

import { useSelector, useDispatch } from 'react-redux';
import { selectUserInConsult } from '@nice-ccf/ui-components';

import { UserConferenceHeader } from './user-conference-header/user-conference-header';
import { UserInConsult } from './user-in-consult/user-in-consult';
import { UserInLobby } from './user-in-lobby/user-in-lobby';
import { UsersInConference } from './users-in-conference/users-in-conference';
import { UserConferenceFooter } from './user-conference-footer/user-conference-footer';
import ReactDOM from 'react-dom';
import { useTranslator } from '@nice-ccf/ui-controls';

/* eslint-disable-next-line */
export interface CcfCallConferenceProps {
  domNodeId?: string;
  className?: string;
}

/**
 * Function for call conference
 * @param props - CcfCallConferenceProps
 * @example <CcfCallConference />
 * @returns
 */
export function CcfCallConference(props: CcfCallConferenceProps) {
  const { domNodeId, className } = props;
  let node;
  if (domNodeId) {
    node = document.getElementById(domNodeId);
  }
  return node ? (
    ReactDOM.createPortal(
      <CcfCallConferenceComponent className={className} />,
      node
    )
  ) : (
    <CcfCallConferenceComponent className={className} />
  );
}

/**
 * Component for call conference
 * @param param0 - className
 * @example - <CcfCallConferenceComponent />
 * @returns
 */
const CcfCallConferenceComponent = ({ className }: { className?: string }) => {
  const status = useSelector(selectCallConferenceStatus);
  const usersInCall = useSelector(selectUserInConference);
  const userInLobby = useSelector(selectUserInLobby);
  const userInConsult = useSelector(selectUserInConsult);
  const tileDirection = useSelector(selectTileDirection);

  const HoldIcons = [...callConferenceCommonIcons, ...callConferenceHoldIcons];
  const ConferenceIcons = [
    ...callConferenceCommonIcons,
    ...callConferenceIcons,
  ];

  const icons = tileDirection ? HoldIcons : ConferenceIcons;

  const dispatch = useDispatch();
  const [translate] = useTranslator();

  const { switchUser, addUserToConference, resetState } = ccfCallActions;

  /**
   * Function to dispatch switch user action
   * @example dispatchSwitchUserAction()
   */
  function dispatchSwitchUserAction() {
    dispatch(switchUser());
  }

  /**
   * Function to dispatch add user to conference action
   * @example dispatchAddUserToConference()
   */
  function dispatchAddUserToConference() {
    dispatch(addUserToConference());
  }

  /**
   * Function to dispatch reset state action
   * @example dispatchResetState()
   */
  function dispatchResetState() {
    dispatch(resetState());
  }
  return (
    <Card className={`${className} ${classes.callConferenceContainer}`}>
      <div className={classes.userConferenceHeader}>
        <UserConferenceHeader />
      </div>
      <CardContent
        classes={{
          root: tileDirection
            ? classes.content
            : `${classes.content} ${classes.contentReverse}`,
        }}
      >
        <UserInConsult user={userInConsult as User} icons={icons} />
        {status !== 'conference' && (
          <Divider classes={{ root: classes.divider }} />
        )}
        <UserInLobby
          user={userInLobby as User}
          dispatchSwitchUserAction={dispatchSwitchUserAction}
          dispatchAddUserToConference={dispatchAddUserToConference}
          showActionButton={tileDirection}
          animate={true}
        />
        <UsersInConference users={usersInCall} icons={icons} />
        <UserConferenceFooter
          status={status}
          dispatchResetState={dispatchResetState}
        />
      </CardContent>
    </Card>
  );
};

export default CcfCallConference;
